"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bubble = void 0;
class Bubble {
    constructor(props) {
        this.props = props;
    }
    static fromProps(props) {
        return new Bubble(props);
    }
    toProps() {
        return this.props;
    }
    static create(name, maxChildren) {
        return this.fromProps({
            maxChildren: Math.max(0, maxChildren),
            name,
            childAssignments: [],
        });
    }
    get name() {
        return this.props.name;
    }
    get maxChildren() {
        return this.props.maxChildren;
    }
    get numChildrenTotal() {
        return this.props.childAssignments.reduce((acc, curr) => new Set([...acc, ...curr.childIds]), new Set()).size;
    }
    /** Returns the identifiers of the weeks a child is assigned to this bubble */
    weeksForChild(childId) {
        return this.props.childAssignments
            .filter((ass) => ass.childIds.includes(childId))
            .map((ass) => ass.weekIdentifier);
    }
    childIdsInBubble(weekIdentifier) {
        var _a, _b;
        return ((_b = (_a = this.props.childAssignments.find((week) => week.weekIdentifier === weekIdentifier)) === null || _a === void 0 ? void 0 : _a.childIds) !== null && _b !== void 0 ? _b : []);
    }
    isEmpty(weekIdentifier) {
        return this.childIdsInBubble(weekIdentifier).length === 0;
    }
    isFull(weekIdentifier) {
        return this.childIdsInBubble(weekIdentifier).length >= this.maxChildren;
    }
    numChildren(weekIdentifier) {
        return this.childIdsInBubble(weekIdentifier).length;
    }
    includesChild(weekIdentifier, childId) {
        return this.childIdsInBubble(weekIdentifier).includes(childId);
    }
    withName(name) {
        return Bubble.fromProps({
            ...this.toProps(),
            name,
        });
    }
    withMaxChildren(maxChildren) {
        return Bubble.fromProps({
            ...this.toProps(),
            maxChildren,
        });
    }
    withChildAdded(weekIdentifier, childId) {
        const childIds = [
            ...this.childIdsInBubble(weekIdentifier).filter((id) => id !== childId),
            childId,
        ];
        return Bubble.fromProps({
            ...this.toProps(),
            childAssignments: [
                ...this.toProps().childAssignments.filter((week) => week.weekIdentifier !== weekIdentifier),
                { weekIdentifier, childIds },
            ],
        });
    }
    withChildRemoved(weekIdentifier, childId) {
        const childIds = this.childIdsInBubble(weekIdentifier).filter((id) => id !== childId);
        return Bubble.fromProps({
            ...this.toProps(),
            childAssignments: [
                ...this.toProps().childAssignments.filter((week) => week.weekIdentifier !== weekIdentifier),
                { weekIdentifier, childIds },
            ],
        });
    }
}
exports.Bubble = Bubble;
//# sourceMappingURL=bubble.js.map